import { isCanlan } from './customer-name'

/* Felipe Nunes: Updated Fri, 17 Jan 2025 10:36 PM ( BRT ) */
// If it fails (like if the previously set hardcoded token is expired)
// try setting the hardcoded token again (hopefully a new one)
// {
//   "access_token": "v2.local.Muq0CKRxyscG5_PtZdAQmeEmxpYZ9OxoI1YyAW7oxSv72b65hc8iW1tLSMhpO52mgvV9QGKROH9Pv0d-qlthZFHXHpnFIrivSKv11imtf08w6TBx2pv-lTZXPStKcJxOcWmM9JZ8wPgK9_2yN_1gyCSk9Qg-hyDNgDnbK1oB_UNCK3WvkOcJKc15MxZ3_J15WoQgzEVSma2rY3445DHSQ5WoffeNuNQkfqIYmc5QMwoMZ-EqGs-nvXcCbRvMv94jiJjfAyu0b03Z5JPg7NuYKea0JPG9Oio",
//   "token_type": "Bearer",
//   "expires_in": 604800,
//   "expires_at": "2025-01-25T01:36:02.550353Z",
//   "user": {
//     "id": "TAcc3KT6ikeaqhvL",
//     "email": "michael+planeticeservice@sportninja.com",
//     "created_at": "2022-08-29T23:14:34+00:00",
//     "updated_at": "2025-01-18T01:35:58+00:00",
//     "validated_at": "2022-08-29T23:14:42+00:00"
//   }
// }
const planetIceToken =
  'v2.local.Muq0CKRxyscG5_PtZdAQmeEmxpYZ9OxoI1YyAW7oxSv72b65hc8iW1tLSMhpO52mgvV9QGKROH9Pv0d-qlthZFHXHpnFIrivSKv11imtf08w6TBx2pv-lTZXPStKcJxOcWmM9JZ8wPgK9_2yN_1gyCSk9Qg-hyDNgDnbK1oB_UNCK3WvkOcJKc15MxZ3_J15WoQgzEVSma2rY3445DHSQ5WoffeNuNQkfqIYmc5QMwoMZ-EqGs-nvXcCbRvMv94jiJjfAyu0b03Z5JPg7NuYKea0JPG9Oio'

// {
//   "access_token": "v2.local.74iZv8932iuEDb8nHv16wNLg7otnj-s4pLUd26Ufwy48wgLdQqziORGUeJb95CHtlaqg5F3lfoUWoivweeAOhd-XsZDDjZkRqSJx4LU0CEGRi4weqClReIfZznfMG3X7Ajl1n8NQ5K6uf-4KWhZdegesX0913Lzms9Xh11wuhWkrZ3ctmM6SfB2dbNy0fGSfFKYgnWfZpNho7WkCvzaUE0IldESR_hS4uR6QoVEJa2PkOUwtadrvWVGwvH_gXK2hYHOm87etE8FE1CQ3fg9xT9b2uTz-v0I",
//   "token_type": "Bearer",
//   "expires_in": 604800,
//   "expires_at": "2025-01-25T01:37:44.569494Z",
//   "user": {
//     "id": "oP37ysYCd57bFlkj",
//     "email": "michael+carhaservice@sportninja.com",
//     "created_at": "2022-05-27T18:35:59+00:00",
//     "updated_at": "2025-01-18T01:37:40+00:00",
//     "validated_at": "2022-05-27T18:35:59+00:00"
//   }
// }
const carhaToken =
  'v2.local.74iZv8932iuEDb8nHv16wNLg7otnj-s4pLUd26Ufwy48wgLdQqziORGUeJb95CHtlaqg5F3lfoUWoivweeAOhd-XsZDDjZkRqSJx4LU0CEGRi4weqClReIfZznfMG3X7Ajl1n8NQ5K6uf-4KWhZdegesX0913Lzms9Xh11wuhWkrZ3ctmM6SfB2dbNy0fGSfFKYgnWfZpNho7WkCvzaUE0IldESR_hS4uR6QoVEJa2PkOUwtadrvWVGwvH_gXK2hYHOm87etE8FE1CQ3fg9xT9b2uTz-v0I'

// {
//   "access_token": "v2.local.X2FHCmRNQ0PiybpNOX-j1pr6ZKOeTlzhY8KkXwONtDpEfPPCaziEJkRuAlcxQxp65KRBJ4P2wz1n4z73gpDnWr5zMfBp1XlcN_tC3vMvoDSNWZ7PTw-ObMLveq_g5U_cer273ucNc1XinCj3eb0sQXAy5kBoPIISGpIDvQgeBwDu1E-vDAphrwpySntOLC0xIJoxRv3oVfmtHOOiwO90zt8EAP51bjiMQtkkvQhiqEk7AiQAiEvV0nmYpCfgH4QsI_a8MBQryXl2H9nDn1vUPYE1_RJM",
//   "token_type": "Bearer",
//   "expires_in": 604800,
//   "expires_at": "2025-01-25T01:39:10.462052Z",
//   "user": {
//     "id": "jJkc8qSsffa24rAE",
//     "email": "michael+canlanservice@sportninja.com",
//     "created_at": "2022-05-30T20:39:26+00:00",
//     "updated_at": "2023-05-19T19:59:44+00:00",
//     "validated_at": "2022-05-30T20:39:26+00:00"
//   }
// }
const canlanToken =
  'v2.local.X2FHCmRNQ0PiybpNOX-j1pr6ZKOeTlzhY8KkXwONtDpEfPPCaziEJkRuAlcxQxp65KRBJ4P2wz1n4z73gpDnWr5zMfBp1XlcN_tC3vMvoDSNWZ7PTw-ObMLveq_g5U_cer273ucNc1XinCj3eb0sQXAy5kBoPIISGpIDvQgeBwDu1E-vDAphrwpySntOLC0xIJoxRv3oVfmtHOOiwO90zt8EAP51bjiMQtkkvQhiqEk7AiQAiEvV0nmYpCfgH4QsI_a8MBQryXl2H9nDn1vUPYE1_RJM'

export const getIframeToken = () => {
  const parentUrl =
    window.location !== window.parent.location
      ? window?.document?.referrer
      : window?.document?.location?.href

  let isPlanetIce = false
  if (parentUrl && parentUrl.includes('pacificadulthockey.com')) {
    isPlanetIce = true
  }
  return isCanlan ? canlanToken : isPlanetIce ? planetIceToken : carhaToken
}
